"use client"
import React, {  useEffect, useRef } from 'react'
import { Herosection,  Arrival, Title,   AllHomeProduct } from '@/components'
import MenCategory from '@/components/TopProducts/MenCategory'
import WomenCategory from '@/components/TopProducts/WomenCategory'
import OtherCategory from '@/components/TopProducts/OtherCategory'
import TesterCategory from '@/components/TopProducts/TesterCategory'
import Link from 'next/link'
import { motion, useInView } from "framer-motion";
import { UpperFooter } from '@/components/Footer/UpperFooter'
import { FB_PIXEL_ID , initFacebookPixel, pageview, trackPageView } from "@/utils/facebookPixel";
import { fbConversionAPI } from '@/API/response'
import Slider from '@/components/Brands/BrandSlider'
import TopSaleProducts from '@/components/TopProducts/TopSaleProducts'
import AOS from "aos";
import "aos/dist/aos.css"; 
const HomeClientPage = ({data, brandData, bannerData }) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Only animate once when in view
      offset: 50, // Trigger animation after scrolling 50px
      easing: "ease-in-out",
    });
  }, []);
  useEffect(() => {
    initFacebookPixel();
    trackPageView()
    const sendPageViewEvent = async () => {
      const data = {
        eventName: "PageViewWebsite",
        eventData: {
          page_title: document.title,
          url: window.location.href,
        },
      };
      try {
        const res = await fbConversionAPI(data, "fb-conversion");
      } catch (error) {
        console.error("Error sending event:", error);
      }
    };
    sendPageViewEvent(); 
  }, []);
  const topSaleRef = useRef(null);
  return (
    <>
     <script
          dangerouslySetInnerHTML={{
            __html: `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              
              fbq('init', '${FB_PIXEL_ID}');
              fbq('track', 'PageView');
            `,
          }}
        />
        <noscript>
          <img
            height="1"
            width="1"
            style={{ display: "none" }}
            src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`}
            alt="pixel"
          />
        </noscript>
    <span className='pb-5 h-full'>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      data-aos="fade-down"
    >
      <Herosection bannerData={bannerData}/>
      </motion.div>
      
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
       data-aos="zoom-in"
    >
      <Slider brandData={brandData}/>
      </motion.div>
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
      // transition={{ duration: 0.1, ease: 'easeOut' }}
      data-aos="fade-right"
      
    >
      <TopSaleProducts/>
      </motion.div>
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
       data-aos="zoom-in"
    >
      <TesterCategory/>
      </motion.div>
    <motion.div
     variants={itemVariants}
     data-aos="zoom-in-up"
    >
      <MenCategory/>
      </motion.div>
    <motion.div
     variants={itemVariants}
     data-aos="zoom-out"
    >
      <WomenCategory/>
      </motion.div>
    <motion.div
     variants={itemVariants}
     data-aos="fade-left"
    >
      <OtherCategory/>
      </motion.div>
     
      <span>
        <Title title="Shop" /> 
        <AllHomeProduct productData={data}/>
        <Link href={'/products'} className='w-full flex justify-center  py-5'>
        <div className="relative group ">
        <button type="button"
          className="bg-secondary py-2 min-w-[140px] shadow-xl shadow-gray-500 rounded-full text-pureWhite hover:text-pureWhite text-sm tracking-wider font-medium outline-none  border border-seaGreen active:shadow-inner relative overflow-hidden">
          <span className="relative z-0">See More</span>
          <span className="absolute inset-0 bg-darkBlue transition-all duration-300 ease-out translate-x-[-100%] group-hover:translate-x-0"></span>
        </button>
      </div>
      </Link>
      </span>
      <Title title="New Arrivals" /> 
      <Arrival/>
      <span data-aos="fade-up"
     data-aos-anchor-placement="top-bottom" className='grid grid-cols-1  sm:grid-cols-1 px-4 sm:px-0 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4 '>
        <UpperFooter title='Fast Delivery' url={"/Images/fastdelivery.png"} subtitle='With In 3 to 5 working Days'/>
        <UpperFooter title='24/7 Customer Service' url={"/Images/service.png"} subtitle='Friendly 24/7 customer support'/>
        <UpperFooter title='Money Back Guarantee' url={'/Images/30Days.png'}  subtitle='we return money within 30 days'/>
        </span>
    </span>
    </>
  )
}

export default HomeClientPage

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3, // Time delay between items
      duration: 0.5,
    },
  },
  exit: { opacity: 0 },
}
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeInOut' } },
};
